import DropDownSpread from 'components/DropDownSpread';
import { timeSortValue } from 'components/MarineForecast/TideTable';
import React, { useContext, useEffect, useState } from 'react';
import { DateToString } from 'utils/stringUtils';
import { FixOutputOfEndpointToTheCorrectFormat_TideData } from 'utils/utilsBecauseSQLSucks';
import { borderBottom } from '@mui/system';
import WidgetTimeUpdate from './WidgetTimeUpdate';
import WidgetLoadingAnimation from './WidgetLoadingAnimation';
import { ErrorMessage } from './ErrorMessage';
import { useAPIData } from 'hooks/useAPIData';
import { ColorContext, UniqueWidgetRefreshContext } from 'App';
import Cookies from 'js-cookie';
import { getTideTable } from 'services/weather/marine.service';

let dataCache;

export default function TideTableWidget({
  widgetRefresh,
  setWidgetRefresh,
  dimensions,
  containerSizePx,
}) {
  const [data, setData] = useState();
  const [fetching, setFetching] = useState(true);
  const [error, setError] = useState({ state: false, message: '' });
  useEffect(() => {
    dataCache = null;
    setFetching(true);
  }, [widgetRefresh]);

  const FusionData = useAPIData({
    successCallback: () => {
      setFetching(false);
    },
    errorCallback: () => {
      setError({ state: true, message: 'Error fetching data' });
      setFetching(false);
    },
    fetchingCallback: () => {
      setFetching(true);
    },
  });
  const theme = useContext(ColorContext);
  const uwf = useContext(UniqueWidgetRefreshContext);
  const ROUTE = 'getTideTable';
  const LOCATION = Cookies.get('city') + '-' + Cookies.get('state');
  const UNIQUEKEY = LOCATION + '-' + ROUTE;
  const containerWidth = Number.isFinite(containerSizePx?.width)
    ? containerSizePx.width
    : dimensions?.[0] == 2
      ? 640
      : 320;
  const isWideWidget = dimensions?.[0] == 2 && dimensions?.[1] == 1;
  const isSquareWidget = dimensions?.[0] == 1 && dimensions?.[1] == 1;
  const isTallWidget = dimensions?.[0] == 1 && dimensions?.[1] == 2;
  const compactWidget = isSquareWidget || isTallWidget || containerWidth < 760;
  const shellPadding = isSquareWidget ? 4 : 5;
  const dropdownButtonClassName = compactWidget
    ? 'd-flex flex-column bg-primary w-100 mt-2 p-2 rounded-2'
    : undefined;
  const dropdownTitleClassName = compactWidget ? 'fw-bold justify-content-start' : undefined;
  const dropdownTitleStyle = compactWidget
    ? { fontSize: isSquareWidget ? 14 : 15, lineHeight: 1.15, textAlign: 'left' }
    : undefined;
  const dropdownChevronSize = compactWidget ? (isSquareWidget ? 14 : 16) : undefined;
  const contentHeaderFontSize = isSquareWidget ? 12 : isTallWidget ? 13 : compactWidget ? 14 : 16;
  const contentDateFontSize = isSquareWidget ? 11 : 12;
  const forecastDayHeaderFontSize = isSquareWidget
    ? 12
    : isTallWidget
      ? 13
      : compactWidget
        ? 14
        : 16;
  const forecastTextFontSize = isSquareWidget ? 10.5 : isTallWidget ? 11 : 12;
  const forecastSetLabelFontSize = isSquareWidget ? 10.5 : 11;
  const forecastGap = isSquareWidget ? 6 : 8;
  const forecastListMaxHeight = isSquareWidget
    ? 210
    : isTallWidget
      ? 230
      : compactWidget
        ? 240
        : 250;
  const forecastColumnWidth = isWideWidget && containerWidth >= 720 ? '50%' : '100%';
  const forecastBlockMarginBottom = isSquareWidget ? 12 : 14;
  const forecastBlockHeaderMarginBottom = isSquareWidget ? 6 : 8;
  const setsStacked = !isWideWidget || containerWidth < 720;
  const tableHeaderLayoutStyle = compactWidget
    ? {
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 4,
      }
    : null;
  const setColumnsStyle = {
    display: 'flex',
    flexDirection: setsStacked ? 'column' : 'row',
    justifyContent: 'space-between',
    gap: setsStacked ? 8 : 12,
    fontSize: forecastTextFontSize,
    lineHeight: 1.2,
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        FusionData.forceGet({
          key: ROUTE,
          apiFunction: getTideTable,
        }).then((res) => {
          res.data.result.map((item) => {
            if (typeof item.tide === 'string') {
              item.tide = JSON.parse(item.tide);
            }
          });

          const fixedData = FixOutputOfEndpointToTheCorrectFormat_TideData(res);

          dataCache = [...fixedData];
          setData(dataCache);

          setFetching(false);
        });
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setFetching(false);
      }
    };

    fetchData();
  }, [uwf[UNIQUEKEY]]);

  useEffect(() => {
    if (dataCache) {
      setData(dataCache);
      setFetching(false);
      return;
    }
    FusionData.get({
      key: ROUTE,
      apiFunction: getTideTable,
    })
      .then((res) => {
        res.data.result.map((item) => {
          if (typeof item.tide === 'string') {
            item.tide = JSON.parse(item.tide);
          }
        });

        const fixedData = FixOutputOfEndpointToTheCorrectFormat_TideData(res);

        dataCache = [...fixedData];
        setData(dataCache);

        setFetching(false);
      })
      .catch((err) => {
        setError({ state: true, message: err.message });
      });
  }, [widgetRefresh]);
  if (error.state && !fetching) {
    return (
      <ErrorMessage
        message={error.message}
        retryRoute={ROUTE}
        onRetry={() => {
          setError({ state: false, message: '' });
          setFetching(true);
        }}
      />
    );
  }

  // if (true)
  if (fetching) return <WidgetLoadingAnimation widgetName={'TideTable'} dimensions={dimensions} />;

  if (data && data.length === 0) {
    return (
      <div>
        <WidgetTimeUpdate route={ROUTE} updateIntervalMinutes={60} />
        <div style={{ padding: 15 }}>No data found.</div>
      </div>
    );
  }

  if (dimensions[0] == 2 && dimensions[1] == 1)
    return (
      <div style={{ height: '100%' }}>
        <WidgetTimeUpdate route={ROUTE} />
        <div
          className="scrollbar-hidden"
          style={{
            display: 'flex',
            flexDirection: 'column',
            padding: shellPadding,
            // height: "85%",
            height: 'calc(100% - 50px)',
            // height: 400,
            overflow: 'auto',
          }}
        >
          {/* No data */}
          {(!data || data.length == 0) && (
            <div
              style={{
                display: 'flex',
                width: '100%',
                height: '100%',
                backgroundColor: theme.base,
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              No Data for this Location
            </div>
          )}

          {/* Data */}
          {data &&
            data?.length > 0 &&
            data.map((item, index) => {
              return (
                <DropDownSpread
                  key={index}
                  title={item.location}
                  buttonClassName={dropdownButtonClassName}
                  titleClassName={dropdownTitleClassName}
                  titleStyle={dropdownTitleStyle}
                  chevronSize={dropdownChevronSize}
                  style={{
                    backgroundColor: theme.primary,
                  }}
                  content={
                    <div
                      style={{
                        width: '100%',
                        backgroundColor: theme.primary,
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          width: '100%',
                          borderBottom: 'solid grey 2px',
                          fontSize: contentHeaderFontSize,
                          fontWeight: 'bold',
                          ...(tableHeaderLayoutStyle || {}),
                        }}
                      >
                        {item.location}
                        <div style={{ fontSize: contentDateFontSize, lineHeight: 1.1 }}>
                          {DateToString(new Date()).month} {DateToString(new Date()).day}{' '}
                          {DateToString(new Date()).year}
                        </div>
                      </div>
                      <div
                        className="scrollbar-hidden"
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          flexWrap: 'wrap',
                          // width: "50%",
                          gap: forecastGap,
                          maxHeight: forecastListMaxHeight,
                          overflow: 'auto',
                          // marginTop: 15,
                        }}
                      >
                        {item.forecast.map((forecast, findex) => {
                          const dateStr = DateToString(new Date(forecast.iso8601));
                          const sortedTides = forecast.tide.sort((a, b) => {
                            return timeSortValue(a, b);
                          });

                          return (
                            <div
                              key={findex}
                              style={{
                                width: forecastColumnWidth,
                                // backgroundColor: "red"
                                marginBottom: forecastBlockMarginBottom,
                                // borderBottom: "solid grey 2px",
                                textAlign: 'left',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  // alignItems: "center",
                                  justifyContent: 'space-between',
                                  width: '100%',
                                  // fontWeight: "bold",
                                  fontSize: forecastDayHeaderFontSize,
                                  marginBottom: forecastBlockHeaderMarginBottom,
                                  lineHeight: 1.1,
                                }}
                              >
                                {`${dateStr.month} ${dateStr.day} ${dateStr.year}`}
                              </div>
                              <div style={setColumnsStyle}>
                                <div style={{ minWidth: 0 }}>
                                  <div
                                    style={{ marginBottom: 4, fontSize: forecastSetLabelFontSize }}
                                  >
                                    Set One
                                  </div>
                                  <div>{`${sortedTides[0].time} ${sortedTides[0].height} ft HIGH`}</div>
                                  <div>{`${sortedTides[2].time} ${sortedTides[2].height} ft LOW`}</div>
                                </div>
                                <div style={{ minWidth: 0 }}>
                                  <div
                                    style={{ marginBottom: 4, fontSize: forecastSetLabelFontSize }}
                                  >
                                    Set Two
                                  </div>
                                  <div>{`${sortedTides[1].time} ${sortedTides[1].height} ft HIGH`}</div>
                                  <div>{`${sortedTides[3].time} ${sortedTides[3].height} ft LOW`}</div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  }
                />
              );
            })}
        </div>
      </div>
    );
  if (dimensions[0] == 1 && dimensions[1] == 1)
    return (
      <div style={{ height: '100%' }}>
        <WidgetTimeUpdate route={ROUTE} />
        <div
          className="scrollbar-hidden"
          style={{
            display: 'flex',
            flexDirection: 'column',
            padding: shellPadding,
            // height: "85%",
            // height: 400,
            height: 'calc(100% - 46px)',
            overflow: 'auto',
          }}
        >
          {/* No data */}
          {(!data || data.length == 0) && (
            <div
              style={{
                display: 'flex',
                width: '100%',
                height: '100%',
                backgroundColor: theme.base,
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              No Data for this Location
            </div>
          )}

          {/* Data */}
          {data &&
            data?.length > 0 &&
            data.map((item, index) => {
              return (
                <DropDownSpread
                  key={index}
                  title={item.location}
                  buttonClassName={dropdownButtonClassName}
                  titleClassName={dropdownTitleClassName}
                  titleStyle={dropdownTitleStyle}
                  chevronSize={dropdownChevronSize}
                  style={{
                    backgroundColor: theme.primary,
                  }}
                  content={
                    <div style={{ width: '100%', backgroundColor: theme.primary }}>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          width: '100%',
                          borderBottom: 'solid grey 2px',
                          fontSize: contentHeaderFontSize,
                          fontWeight: 'bold',
                          ...(tableHeaderLayoutStyle || {}),
                        }}
                      >
                        {item.location}
                        <div style={{ fontSize: contentDateFontSize, lineHeight: 1.1 }}>
                          {DateToString(new Date()).month} {DateToString(new Date()).day}{' '}
                          {DateToString(new Date()).year}
                        </div>
                      </div>
                      <div
                        className="scrollbar-hidden"
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          flexWrap: 'wrap',
                          // width: "50%",
                          gap: forecastGap,
                          maxHeight: forecastListMaxHeight,
                          overflow: 'auto',
                          // marginTop: 15,
                        }}
                      >
                        {item.forecast.map((forecast, findex) => {
                          const dateStr = DateToString(new Date(forecast.iso8601));
                          const sortedTides = forecast.tide.sort((a, b) => {
                            return timeSortValue(a, b);
                          });

                          return (
                            <div
                              key={findex}
                              style={{
                                width: forecastColumnWidth,
                                // backgroundColor: "red"
                                marginBottom: forecastBlockMarginBottom,
                                // borderBottom: "solid grey 2px",
                                textAlign: 'left',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  // alignItems: "center",
                                  justifyContent: 'space-between',
                                  width: '100%',
                                  // fontWeight: "bold",
                                  fontSize: forecastDayHeaderFontSize,
                                  marginBottom: forecastBlockHeaderMarginBottom,
                                  lineHeight: 1.1,
                                }}
                              >
                                {`${dateStr.month} ${dateStr.day} ${dateStr.year}`}
                              </div>
                              <div style={setColumnsStyle}>
                                <div style={{ minWidth: 0 }}>
                                  <div
                                    style={{ marginBottom: 4, fontSize: forecastSetLabelFontSize }}
                                  >
                                    Set One
                                  </div>
                                  <div>{`${sortedTides[0].time} ${sortedTides[0].height} ft HIGH`}</div>
                                  <div>{`${sortedTides[2].time} ${sortedTides[2].height} ft LOW`}</div>
                                </div>
                                <div style={{ minWidth: 0 }}>
                                  <div
                                    style={{ marginBottom: 4, fontSize: forecastSetLabelFontSize }}
                                  >
                                    Set Two
                                  </div>
                                  <div>{`${sortedTides[1].time} ${sortedTides[1].height} ft HIGH`}</div>
                                  <div>{`${sortedTides[3].time} ${sortedTides[3].height} ft LOW`}</div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  }
                />
              );
            })}
        </div>
      </div>
    );

  if (dimensions[0] == 1 && dimensions[1] == 2)
    return (
      <div style={{ height: '100%' }}>
        <WidgetTimeUpdate route={ROUTE} />
        <div
          className="scrollbar-hidden"
          style={{
            display: 'flex',
            flexDirection: 'column',
            padding: shellPadding,
            // height: "85%",
            height: 'calc(100% - 46px)',
            overflow: 'auto',
          }}
        >
          {/* No data */}
          {(!data || data.length == 0) && (
            <div
              style={{
                display: 'flex',
                width: '100%',
                height: '100%',
                backgroundColor: theme.base,
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              No Data for this Location
            </div>
          )}

          {/* Data */}
          {data &&
            data?.length > 0 &&
            data.map((item, index) => {
              return (
                <DropDownSpread
                  key={index}
                  title={item.location}
                  buttonClassName={dropdownButtonClassName}
                  titleClassName={dropdownTitleClassName}
                  titleStyle={dropdownTitleStyle}
                  chevronSize={dropdownChevronSize}
                  style={{
                    backgroundColor: theme.primary,
                  }}
                  content={
                    <div style={{ width: '100%', backgroundColor: theme.primary }}>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          width: '100%',
                          borderBottom: 'solid grey 2px',
                          fontSize: contentHeaderFontSize,
                          fontWeight: 'bold',
                          ...(tableHeaderLayoutStyle || {}),
                        }}
                      >
                        {item.location}
                        <div style={{ fontSize: contentDateFontSize, lineHeight: 1.1 }}>
                          {DateToString(new Date()).month} {DateToString(new Date()).day}{' '}
                          {DateToString(new Date()).year}
                        </div>
                      </div>
                      <div
                        className="scrollbar-hidden"
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          flexWrap: 'wrap',
                          // width: "50%",
                          gap: forecastGap,
                          maxHeight: forecastListMaxHeight,
                          overflow: 'auto',
                          // marginTop: 15,
                        }}
                      >
                        {item.forecast.map((forecast, findex) => {
                          const dateStr = DateToString(new Date(forecast.iso8601));
                          const sortedTides = forecast.tide.sort((a, b) => {
                            return timeSortValue(a, b);
                          });

                          return (
                            <div
                              key={findex}
                              style={{
                                width: forecastColumnWidth,
                                // backgroundColor: "red"
                                marginBottom: forecastBlockMarginBottom,
                                // borderBottom: "solid grey 2px",
                                textAlign: 'left',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  // alignItems: "center",
                                  justifyContent: 'space-between',
                                  width: '100%',
                                  // fontWeight: "bold",
                                  fontSize: forecastDayHeaderFontSize,
                                  marginBottom: forecastBlockHeaderMarginBottom,
                                  lineHeight: 1.1,
                                }}
                              >
                                {`${dateStr.month} ${dateStr.day} ${dateStr.year}`}
                              </div>
                              <div style={setColumnsStyle}>
                                <div style={{ minWidth: 0 }}>
                                  <div
                                    style={{ marginBottom: 4, fontSize: forecastSetLabelFontSize }}
                                  >
                                    Set One
                                  </div>
                                  <div>{`${sortedTides[0].time} ${sortedTides[0].height} ft HIGH`}</div>
                                  <div>{`${sortedTides[2].time} ${sortedTides[2].height} ft LOW`}</div>
                                </div>
                                <div style={{ minWidth: 0 }}>
                                  <div
                                    style={{ marginBottom: 4, fontSize: forecastSetLabelFontSize }}
                                  >
                                    Set Two
                                  </div>
                                  <div>{`${sortedTides[1].time} ${sortedTides[1].height} ft HIGH`}</div>
                                  <div>{`${sortedTides[3].time} ${sortedTides[3].height} ft LOW`}</div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  }
                />
              );
            })}
        </div>
      </div>
    );
}
